import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

async function create(data) {
  const response = await http
    .postData("/asesmen-risiko-jatuh", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function update(id, data) {
  const response = await http
    .putData(`/asesmen-risiko-jatuh/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function getByRegister(
  register_id: string | number,
  params: {
    page: number;
    per_page: number;
    sort_by: string;
    sort_desc: boolean;
  } = null
) {
  const response = await http
    .getDataParam(
      `/register/${register_id}/asesmen-risiko-jatuh`,
      params
        ? {
            params: params
          }
        : null
    )
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function find(id: number) {
  const response = await http
    .getData(`/asesmen-risiko-jatuh/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`/asesmen-risiko-jatuh/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

function print(id) {
  window.open(`${http.getAPI()}/asesmen-risiko-jatuh/${id}/pdf`, "_blank");
}

export default {
  create,
  update,
  getByRegister,
  find,
  destroy,
  print
};
